import ContactForm from "@/components/ContactForm";
import SEOHead from "@/components/SEOHead";
import { COMPANY } from "@/data/content";
import { Phone, Mail, MapPin, Clock, MessageSquare } from "lucide-react";

export default function ContactPage() {
  return (
    <>
      <SEOHead
        title="Kontakt – EasyRohbau | Köln · Bonn · Düsseldorf"
        description="Kontaktieren Sie EasyRohbau für Ihre Rohbau-Anfrage. Telefon, E-Mail oder WhatsApp – wir melden uns binnen 24h."
      />
      <section className="pt-32 pb-16 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-4">Kontakt</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#0C2749] tracking-tight max-w-3xl" style={{ fontFamily: "Outfit" }}>
            Lassen Sie uns sprechen.
          </h1>
          <p className="text-slate-600 max-w-2xl mt-6">
            Wir freuen uns auf Ihr Projekt. Persönlich, telefonisch, per E-Mail oder WhatsApp – Sie wählen den Kanal.
          </p>
        </div>
      </section>

      <section className="pb-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 space-y-4">
            <ContactItem icon={Phone} label="Telefon" value={COMPANY.phone} href={`tel:${COMPANY.phoneRaw}`} testid="contact-info-phone" />
            <ContactItem icon={Mail} label="E-Mail" value={COMPANY.email} href={`mailto:${COMPANY.email}`} testid="contact-info-email" />
            <ContactItem icon={MessageSquare} label="WhatsApp" value="Direkt schreiben" href={`https://wa.me/${COMPANY.whatsapp}`} testid="contact-info-whatsapp" />
            <ContactItem icon={MapPin} label="Adresse" value={COMPANY.address} testid="contact-info-address" />
            <ContactItem icon={Clock} label="Öffnungszeiten" value={COMPANY.hours} testid="contact-info-hours" />
          </div>
          <div className="lg:col-span-7">
            <ContactForm source="kontaktseite" />
          </div>
        </div>
      </section>

      <section className="bg-[#F5F5F5] py-16">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-4">Standort</p>
          <h2 className="text-3xl font-bold text-[#0C2749] mb-8" style={{ fontFamily: "Outfit" }}>So finden Sie uns</h2>
          <div className="aspect-[16/8] w-full bg-slate-200 overflow-hidden rounded-sm">
            <iframe
              title="EasyRohbau Standort"
              src="https://www.google.com/maps?q=Köln,Industriestraße&output=embed"
              className="w-full h-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="contact-map"
            />
          </div>
        </div>
      </section>
    </>
  );
}

function ContactItem({ icon: Icon, label, value, href, testid }) {
  const Wrap = href ? "a" : "div";
  return (
    <Wrap href={href} target={href?.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" className="flex items-start gap-4 bg-[#F5F5F5] p-6 rounded-sm hover:bg-[#0C2749] hover:text-white transition-colors group" data-testid={testid}>
      <span className="inline-flex h-10 w-10 items-center justify-center bg-white text-[#2873B8] rounded-sm group-hover:bg-[#2C80C8] group-hover:text-white">
        <Icon className="w-5 h-5" />
      </span>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-slate-500 group-hover:text-white/70">{label}</p>
        <p className="text-base font-semibold text-[#0C2749] group-hover:text-white" style={{ fontFamily: "Outfit" }}>{value}</p>
      </div>
    </Wrap>
  );
}
